var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBleaching(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bleach",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.771,
    height: 26.048,
    viewBox: "0 0 15.771 26.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M100,0h5.6V2.035H100Zm0,0",
    transform: "translate(-94.912)",
    fill: "#9b9b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M14.2,73.742C13.028,71.329,11.507,70,9.921,70H5.851c-1.586,0-3.107,1.329-4.284,3.742A15.72,15.72,0,0,0,0,80.175V92.487H15.772V80.175A15.72,15.72,0,0,0,14.2,73.742ZM6.359,89.435H3.053V87.908H6.359Zm1.526-3.053H3.053V84.856H7.886Zm4.579-6.359a1.526,1.526,0,1,1-3.053,0V76.97a1.526,1.526,0,1,1,3.053,0Zm0,0",
    transform: "translate(0 -66.439)",
    fill: "#9b9b9b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBleaching);
export default __webpack_public_path__ + "static/media/bleaching.aa9b012daeb55e7b2047eb94b89c69a2.svg";
export { ForwardRef as ReactComponent };